// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_azure_msal-browser_dist_controllers_NestedAppAuthController_mjs":"62c126ee95970594","node_modules_dompurify_dist_purify_js":"e4dacefc0e9ed284","node_modules_canvg_lib_index_es_js":"eb3575478b35b3b6"}[chunkId] + ".js";
};